import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import Grid from '../Grid';
import Popup from './Popup';
import s from './Popup.css';
import Messages from './Messages';

class ConfigurationPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {

    };
  }

  render() {
    const { intl, devicetype, bottle, valve, medium } = this.props;
    const messages = Messages();
    const bottleLower = bottle.toLowerCase();
    const value = `medium_${medium}_softener_text`; //medium
    const bottleValue = `${bottleLower}_bottle_text`; //bottle

    console.log('value, bottleValue', value, bottleValue);
    return (
      <Popup
        className={s.Popup__editdevice}
        onClose={this.props.onClose}
        devicetype={devicetype}
        overrideOnClose
      >
        <div>
          <Grid.Cell className={'u_size6of12'}>
            <FormattedMessage {...messages.bottle_configuration_main_screen_text} />
          </Grid.Cell>
          <Grid.Cell className={'u_size6of12'}>
            <FormattedMessage {...messages[bottleValue]}/>
          </Grid.Cell>
          <Grid.Cell className={'u_size6of12'}>
            <FormattedMessage {...messages.valve_main_screen_text} />
          </Grid.Cell>
          <Grid.Cell className={'u_size6of12'}>{valve}</Grid.Cell>
          <Grid.Cell className={'u_size6of12'}>Medium</Grid.Cell>
          <Grid.Cell className={'u_size6of12'}>
            <FormattedMessage {...messages[value]}/>
          </Grid.Cell>
        </div>
      </Popup>
    );
  }
}

ConfigurationPopUp.propTypes = {
  onClose: PropTypes.func.isRequired,
  saveDeviceData: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  bottle: PropTypes.string.isRequired,
  valve: PropTypes.string,
  medium: PropTypes.string,
};

export default injectIntl(withStyles(s)(ConfigurationPopUp));



// WEBPACK FOOTER //
// ./src/components/Popup/ConfigurationPopUp.js